<template>
    <div>
        <div v-if="$vuetify.breakpoint.lgAndUp">
            <div style="height: 40px; background-color:#141C2E;" class="mb-3"></div>
            <div class="pa-3">
                <v-card v-for="items in matches" :key="items.title" flat style="background-color:rgba(20,28,46,.50); border:none;" class="mb-7 rounded-b-0">
                    <div class="text-start font-weight-bold pa-2 pb-0">{{items.title}} <span><v-icon class="float-end" @click="removeMain(items)">mdi-close</v-icon></span></div>
                    <v-card v-for="item in items.matches" :key="item.name" class="mt-5" tile flat style="background-color:#141C2E; border:none;">
                        <v-row>
                            <v-col class="py-0 pt-2 pr-6"><v-icon small class="float-right" @click="removeSub(items.title, item)">mdi-close</v-icon></v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" class="pt-0">
                                <div class="text-start mx-3 font-weight-bold">{{item.name}}:</div>
                            </v-col>
                            <v-col cols="6" class="pt-0">
                                <div class="text-start mx-3 font-weight-bold">Odds Ratio:</div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" class="d-flex align-center py-0">
                                <div class="pl-5 pr-3"><v-img :src="item.image" class="float-right" width="50px"></v-img></div>
                                <div class="text-start">{{item.team}}</div>
                            </v-col>
                            <v-col cols="6" class="d-flex align-center">
                                <div class="text-start mx-10">{{item.odds}}</div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" class="pb-0">
                                <div class="text-start mx-3 font-weight-bold mb-1">Amount You Bet:</div>
                            </v-col>
                            <v-col cols="6" class="pb-0">
                                <div class="text-start mx-3 font-weight-bold mb-1">Possible Payout:</div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" class="pt-0">
                                <v-btn outlined class="my-1" color="#00EBAE"><div class="tw-text-white">₱ {{item.amount}}.00</div></v-btn>
                            </v-col>
                            <v-col cols="6" class="d-flex justify-center align-center pt-0">
                                <div class="font-weight-bold" style="color:#00EBAE;"><span class="mr-2">₱</span> {{item.possible}}.00</div>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-card>
            </div>
            <div class="mt-5 mb-3" style="background-color:#141C2E;">
                <v-row class="d-flex align-center">
                    <v-col cols="5" class="pr-0">
                        <div class="text-start text-body-2 pl-3 mb-1">Total Amount Bet</div>
                        <div class="text-start text-body-2 pl-3">Total Possible Winnings</div>
                    </v-col>
                    <v-col cols="3">
                        <div class="text-start text-body-2 mb-1">₱ {{total_amount_bet}}.00</div>
                        <div class="text-start text-body-2 font-weight-bold" style="color:#00EBAE">₱ 1,215.00</div>
                    </v-col>
                    <v-col cols="4" class="d-flex justify-center px-0 pr-3" style="background-color:#D28945">
                        <a><div class="tw-text-white font-weight-bold py-6">{{total_amount_bet > credits ? 'DEPOSIT' : 'PLACE A BET'}}</div></a>
                    </v-col>
                </v-row>
            </div>
        </div>
        <div v-else>
            <div style="background:#141C2E; border: 1px solid black;" class="rounded-xl rounded-b-0">
                <div class="font-weight-bold tw-text-white text-body-1 py-3">BET SLIP</div>
                <div class="px-10 pb-10">
                    <v-card v-for="items in matches" :key="items.title" style="background-color:rgba(13,17,27,.50); border: none;" class="mb-7 rounded-b-0">
                        <div class="text-start font-weight-bold pa-2 pb-0">{{items.title}} <span><v-icon small class="float-end" @click="removeMain(items)">mdi-close</v-icon></span></div>
                        <v-card v-for="item in items.matches" :key="item.name" class="mt-5" tile flat style="background-color:rgba(13,17,27,1); border:none;">
                            <v-row>
                                <v-col class="py-0 pt-2 pr-6"><v-icon x-small class="float-right" @click="removeSub(items.title, item)">mdi-close</v-icon></v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6" class="pt-0">
                                    <div class="text-start mx-3 font-weight-bold" style="font-size: 12px !important;">{{item.name}}:</div>
                                </v-col>
                                <v-col cols="6" class="pt-0">
                                    <div class="text-start mx-3 font-weight-bold" style="font-size: 12px !important;">Odds Ratio:</div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6" class="d-flex align-center py-0">
                                    <div class="pl-5 pr-3"><v-img :src="item.image" class="float-right" width="40px"></v-img></div>
                                    <div class="text-start">{{item.team}}</div>
                                </v-col>
                                <v-col cols="6" class="d-flex align-center">
                                    <div class="text-start mx-10">{{item.odds}}</div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6" class="pb-0">
                                    <div class="text-start mx-3 font-weight-bold mb-1" style="font-size: 12px !important;">Amount You Bet:</div>
                                </v-col>
                                <v-col cols="6" class="pb-0">
                                    <div class="text-start mx-3 font-weight-bold mb-1" style="font-size: 12px !important;">Possible Payout:</div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6" class="pt-0">
                                    <v-btn small outlined class="my-1" color="#00EBAE"><div class="tw-text-white">₱ {{item.amount}}.00</div></v-btn>
                                </v-col>
                                <v-col cols="6" class="d-flex justify-center align-center pt-0">
                                    <div class="font-weight-bold" style="color:#00EBAE; font-size: 12px !important;"><span class="mr-2">₱</span> {{item.possible}}.00</div>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-card>
                    <div class="mt-3 mb-3" style="background-color:#0D111B;">
                        <v-col>
                            <v-row class="d-flex align-center">
                                <v-col cols="8" class="px-2">
                                    <v-row class="d-flex align-center">
                                        <v-col cols="8" class="pa-0">
                                            <div class="text-start text-body-2 pl-3 mb-1" style="font-size: 10px !important;">Total Amount Bet</div>
                                        </v-col>
                                        <v-col cols="4" class="pa-0">
                                            <div class="text-start text-body-2 mb-1" style="font-size: 10px !important;">₱ {{total_amount_bet}}.00</div>
                                        </v-col>
                                    </v-row>
                                    <v-row class="d-flex align-center">
                                        <v-col cols="8" class="pa-0">
                                            <div class="text-start text-body-2 pl-3" style="font-size: 10px !important;">Total Possible Winnings</div>
                                        </v-col>
                                        <v-col cols="4" class="pa-0">
                                            <div class="text-start text-body-2 font-weight-bold" style="color:#00EBAE; font-size: 10px !important;">₱ 1,215.00</div>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="4" class="d-flex justify-center px-2" style="background-color:#D28945">
                                    <a><div class="tw-text-white font-weight-bold py-3" style="font-size: 12px !important;">{{total_amount_bet > credits ? 'DEPOSIT' : 'PLACE A BET'}}</div></a>
                                </v-col>
                            </v-row>
                        </v-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            credits: 800,
            total_amount_bet: 700,
            matches: [
                {
                    title: "Boom Esports vs Yangon Galacticos",
                    matches: [
                        {
                            name: "Match Winner",
                            image: require('@/assets/images/Boom.svg'),
                            team: "Boom Esports",
                            odds: "x1.35",
                            amount: "100",
                            possible: "135"
                        },
                        {
                            name: "First 10 Kills",
                            image: require('@/assets/images/Boom.svg'),
                            team: "Boom Esports",
                            odds: "x1.85",
                            amount: "120",
                            possible: "185"
                        }
                    ]
                },
                {
                    title: "Virtus.pro vs Fnatic",
                    matches: [
                        {
                            name: "Match Winner",
                            image: require('@/assets/images/Fnatic.svg'),
                            team: "Fnatic",
                            odds: "x1.35",
                            amount: "100",
                            possible: "135"
                        },
                        {
                            name: "Fnatic +1.5",
                            image: require('@/assets/images/Fnatic.svg'),
                            team: "Fnatic",
                            odds: "x1.85",
                            amount: "120",
                            possible: "185"
                        }
                    ]
                }
            ]
        }
    },
    methods: {
        removeMain(item) {
            this.matches.splice(this.matches.indexOf(item), 1);
        },
        removeSub(title, item) {
            const match = this.matches.find(element => element.title == title);
            match.matches.splice(match.matches.indexOf(item), 1);
            if (match.matches.length == 0) {
                this.removeMain(match);
            }
        }
    }
};
</script>